import { DisplayText } from './displayText';

export class EventColumn {
    isDefault: boolean;
    column: DisplayText;

    constructor(isDefault: boolean, column: DisplayText) {
        this.isDefault = isDefault;
        this.column = column;
    }
}
